import { Vector2 } from 'three';
import Representation2d from './Representation2d';
import ShapeTypeEnum from './ShapeTypeEnum';
import apiShapeRepresentation2dSchema from '../../services/bimVisualizerApi/schema/representation2d/apiShapeRepresentation2dSchema';
import { getScaledVector2 } from '../../utils/scaler';

export default class ShapeRepresentation2d extends Representation2d {
    
    outerProfile: Vector2[] = [];
    voids: Vector2[][] = [];

    constructor(outerProfile: Vector2[], voids: Vector2[][], materialId: number | null) {
        super(ShapeTypeEnum.Shape, materialId);
        this.outerProfile = outerProfile;
        this.voids = voids;
    }
    
    static fromJSON(json: any): Representation2d {

        const parsed = apiShapeRepresentation2dSchema.parse(json);

        const outerProfile = parsed.outerProfile.map((v: any) => getScaledVector2({...v}));

        // TODO: Parse voids

        return new ShapeRepresentation2d(outerProfile, [], parsed.materialId);
    }
}